<div class="special-chart-column-range-component" fxLayout="column">
    <div class="special-chart-column-range-component_bars">
        <div class="special-chart-column-range-component_drills-chart">
            @if (isCustomStructure) {
                <app-highcharts-render
                    style="height: 100%"
                    [chartStructure]="chartStructure"
                ></app-highcharts-render>
            } @else {
                <app-highcharts-render
                    class="full-height"
                    [options]="options"
                    [visualization]="visualization"
                    [series]="series"
                    [points]="points"
                    [company]="company"
                ></app-highcharts-render>
            }
        </div>
    </div>
    <div class="special-chart-column-range-component_drills" fxLayout="column">
        <ul fxLayout="column">
            @for (indicator of indicatorProps; track $index) {
                <li fxLayout="row" fxLayoutAlign="start center">
                    <span
                        class="indicator-color"
                        [style.backgroundColor]="indicator.hexPolarityColor"
                    ></span
                    ><span class="text-12-semi-bold"
                        >{{ indicator.serie.serieLabel.title }}:<span
                            class="special-chart-column-range-component_drills-indicator-li"
                            >{{ indicator.days }}</span
                        ></span
                    >
                </li>
            }
        </ul>
        <!-- @for (indicator of indicatorProps; track $index) {
            <div
                class="special-chart-column-range-component_indicator"
                [style.height]="'71px'"
                [style.minHeight]="'71px'"
            >
                <div
                    class="special-chart-column-range-component_indicator-value"
                    fxLayout="column"
                    fxLayoutAlign="space-between center"
                >
                    <span></span>
                </div>
                <app-chart-historic
                    [options]="options"
                    [visualization]="visualization"
                    [series]="[indicator.serie]"
                    [points]="points"
                    [company]="company"
                    [categoryName]="'areaspline'"
                ></app-chart-historic>
            </div>
        } -->
    </div>
</div>
